import { useQuery } from 'react-query'
import client from './api-client'

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

async function fetchForecast(parcel_id, selected_provider) {
    const data = await client(`parcels/${parcel_id}/weather-forecast/?provider=${selected_provider}`)
    return data
}

export function useForecast(parcel_id, selected_provider) {
    return useQuery(['forecast', parcel_id, selected_provider], 
                    () => fetchForecast(parcel_id, selected_provider), {
        refetchAllOnWindowFocus: false,
        enabled: false,
        ...queryConfig
    });
}